<template>
<div style="position: relative;">
  <ContextItem
    v-if="computedDay !== null"
    :attribute="computedDay.attribute"
    :value="computedDay.value"
    :icon="'fas fa-clock'"
    :actionIcons="{edit: 'custom', expand: true}"
    :eventName="'click'"
    @customEditEmitted="dialog = !dialog"
  >
  <template v-slot:expandablePart>
    <div class="context--expandlist__container">
      <div class="context--expandlist__list">
        <ul class="pl-0">
          <li class="context--expandlist__card" :id="opening.day" :key="opening.day" v-for="(opening) in openingHours">
            <span class="context--expandlist__title context--text--alignLeft flex--width--25">
              {{$t(`days.${opening.day}`)}}
            </span>
            <span v-show="opening.isClosed" class="context--expandlist__title context--text--alignLeft flex--width--50">
              {{'Closed'}}
            </span>
            <span v-show="!opening.isNotAllDay" class="context--expandlist__title context--text--alignLeft flex--width--50">
              {{'24 hours'}}
            </span>
            <span v-if="opening.hours.morning != null" class="context--expandlist__title  context--text--alignLeft" :class="[opening.hours.length > 1 ? 'flex--width--12' : 'flex--width--50']">
              {{ opening.hours.morning | openingHoursContext }}
            </span>
            <span v-if="opening.hours.length > 1" class="context--expandlist__title  context--text--alignLeft flex--width--25">
              {{`${opening.hours[1][0]} - ${opening.hours[1][1]}`}}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </template>
  </ContextItem>
  <!-- <span @click="dialog = !dialog" style="position: absolute; top: 0; left: 90%;"><i class="fas fa-pen"></i></span> -->
  <v-dialog v-model="dialog" width="900">
    <v-card class="pa-1">
      <v-card-title>
        <span class="headline font-weight-bold">
          {{ $t('locations.opening_hours') }}
        </span>
      </v-card-title>
      <div class="editing--opening--hours">
        <ul>
          <li :key="index" v-for="({isClosed, day, isNotAllDay, isEditing, hours, focused, customValue}, index) in openingHours">
            <v-row no-gutters>
              <v-col no-gutters cols="2">
                <v-row no-gutters>
                  <v-col cols="3" no-gutters v-if="isClosed">
                    <v-icon
                    @click="handleClosed('open', index)"
                    >
                    far fa-square
                    </v-icon>
                  </v-col>
                  <v-col cols="3" v-else>
                    <v-icon
                    @click="handleClosed('close', index)"
                    >
                    fas fa-check-square
                    </v-icon>
                  </v-col>
                  <v-col cols="9" no-gutters>
                    {{$t(`days.${day}`)}}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" no-gutters>
                <v-row no-gutters v-show="!isClosed">
                  <v-col
                    cols="3"
                    v-if="isNotAllDay"
                    no-gutters
                  >
                    <v-icon
                    @click="handleAllDay('open', index)">
                      far fa-square
                    </v-icon>
                  </v-col>
                  <v-col
                  cols="3"
                  v-else
                  no-gutters
                  >
                    <v-icon @click="handleAllDay('close', index)">
                      fas fa-check-square
                    </v-icon>
                  </v-col>
                  <v-col>
                    {{$t('organizations.all_day')}}
                  </v-col>
                </v-row>
              </v-col>
            <v-col
            cols="4"
            no-gutters
            @click="handleAddInterval('open_1', 0, index, 'add')"
            v-show="isEditing === -1"
            :style="[!isNotAllDay || isClosed ? 'visibility: hidden;': '']"
            >
              <v-row
              no-gutters
              >
                <v-btn
                  color="wrld_red"
                  small
                >
                  <v-icon
                  left
                  small
                  color="primary_text"
                  >fas fa-plus-circle</v-icon>
                  <span
                    class="primary_text--text"
                  >
                    {{$t('locations.add_interval')}}
                  </span>
                </v-btn>
              </v-row>
            </v-col>
            <v-col
            cols="4"
            no-gutters
            class="timePickers"
            :class="{'visibilityHidden': !isNotAllDay}"
            v-show="hours.morning != null">
            <v-row no-gutters>
              <v-col cols="2" no-gutters>
                <v-menu offset-y max-height="200px">
                  <template v-slot:activator="{ on }">
                    <input
                      v-on="on"
                      type="text"
                      maxlength="5"
                      @input="handleTypeTime($event, 'morning', 'from', 0, index)"
                      @focus="handleFocusInput($event, 0, 0, index, 0)"
                      @blur="handleBlurInput($event, 'morning', 0, index, 0)"
                      :value="customValue[0]"
                    />
                  </template>
                  <v-list
                    v-show="focused[0]"
                  >
                    <v-list-item
                      :class="{'bgLight': hourIndex%2}"
                      v-for="(hour, hourIndex) in computedOpenHours"
                      :key="`${hour}_${day}_morning_from`"
                      @click="handleSelectValue(hour, 'morning', 'from', index, 0)"

                    >
                      <v-list-item-title>{{hour}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col cols="1" no-gutters>
                <i class="fas fa-minus"></i>
              </v-col>
              <v-col cols="9" no-gutters>
                <v-menu offset-y max-height="200px">
                  <template v-slot:activator="{ on }">
                    <input
                      v-on="on"
                      type="text"
                      maxlength="5"
                      @input="handleTypeTime($event, 'morning', 'to', 1, index)"
                      @focus="handleFocusInput($event, 0, 1, index, 1)"
                      @blur="handleBlurInput($event, 'morning', 1, index, 1)"
                      :value="customValue[1]"
                    />
                  </template>
                  <v-list
                    v-show="focused[1]"
                  >
                    <v-list-item
                      max-height="17px"
                      :class="{'bgLight': hourIndex%2}"
                      v-for="(hour, hourIndex) in computedCloseHours"
                      :key="`${hour}_${day}_morning_to`"
                      @click="handleSelectValue(hour, 'morning', 'to', index, 1)"

                    >
                      <v-list-item-title>{{hour}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            </v-col>
            <v-col
            cols="4"
            no-gutters
            class="timePickers"
            v-show="hours.afternoon != null && isNotAllDay"
            >
              <v-row
                no-gutters
              >
                <v-col cols="2" no-gutters>
                  <v-menu offset-y max-height="200px">
                      <template v-slot:activator="{ on }">
                        <input
                          v-on="on"
                          type="text"
                          maxlength="5"
                          @input="handleTypeTime($event, 'afternoon', 'from', 2, index)"
                          @focus="handleFocusInput($event, 1, 0, index, 2)"
                          @blur="handleBlurInput($event, 'afternoon', 0, index, 2)"
                          :value="customValue[2]"
                        />
                      </template>
                      <v-list
                        v-show="focused[2]"
                      >
                        <v-list-item
                          max-height="8px"
                          :class="{'bgLight': hourIndex%2}"
                          v-for="(hour, hourIndex) in computedOpenHours"
                          :key="`${hour}_${day}_afternoon_from`"
                          @click="handleSelectValue(hour, 'afternoon', 'from', index, 2)"

                        >
                          <v-list-item-title>{{hour}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                </v-col>
                <v-col cols="1" no-gutters>
                    <i class="fas fa-minus"></i>
                </v-col>
                <v-col cols="8" no-gutters>
                  <v-menu offset-y max-height="200px">
                      <template v-slot:activator="{ on }">
                        <input
                          v-on="on"
                          type="text"
                          maxlength="5"
                          @input="handleTypeTime($event, 'afternoon', 'to', 3, index)"
                          @focus="handleFocusInput($event, 1, 1, index, 3)"
                          @blur="handleBlurInput($event, 'afternoon', 1, index, 3)"
                          :value="customValue[3]"
                        />
                      </template>
                      <v-list
                        v-show="focused[3]"
                      >
                        <v-list-item
                          max-height="17px"
                          :class="{'bgLight': hourIndex%2}"
                          v-for="(hour, hourIndex) in computedCloseHours"
                          :key="`${hour}_${day}_afternoon_to`"
                          @click="handleSelectValue(hour, 'afternoon', 'to', index, 3)"

                        >
                          <v-list-item-title>{{hour}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                </v-col>
                 <v-col cols="1" no-gutters>
                    <i
                    @click="removeInterval(index)"
                    class="fas fa-times"
                    ></i>
                </v-col>
              </v-row>
            </v-col>
            <v-col
            class="opening--hours--addinterval"
            @click="handleAddInterval('open_2', 1, index, 'add')"
            v-if="!isClosed && hours.morning != null || !isNotAllDay"
            :style="[!isNotAllDay ? 'display: none;' : '', hours.afternoon != null ? 'display: none;' : '']" >
            <v-row
              no-gutters
              >
                <v-btn
                  color="wrld_red"
                  small
                >
                  <v-icon
                  left
                  small
                  color="primary_text"
                  >fas fa-plus-circle</v-icon>
                  <span
                    class="primary_text--text"
                  >
                    {{$t('locations.add_interval')}}
                  </span>
                </v-btn>
            </v-row>
            </v-col>
            <v-col v-if="isClosed">{{$t('organizations.closed')}}</v-col>
            </v-row>
          </li>
        </ul>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="wrld_red" dark @click="handleSave">{{$t('organizations.save')}}</v-btn>
        <v-btn color="light" @click="handleCancel">{{$t('organizations.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import ContextItem from '@/components/wrld/generic/ContextItem.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'LocationsOpeningHours',
  components: {
    ContextItem
  },
  props: {
    location: { type: Object, default: () => {} }
  },
  data () {
    return {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      openingHours: [],
      dialog: false,
      hours: [],
      minutes30: [],
      minutes15: [],
      availableHours: [],
      filterOpenHours: ['06', '12'],
      filterCloseHours: ['17', '23'],
      typedFilter: '',
      typedUser: '',
      selectedTimePicker: -1,
      notAllowedCharacters: [],
      timeRegex: /^([01][0-9]|2[0-3]):[0-5][0-9]$/,
      searchRegex: /^([01][0-9]|2[0-3])$/,
      searchOneNumberRegex: /^([2-9])$/,
      previousOpeningHours: []
    }
  },
  mounted () {
    // this.createOpeningHours()
    this.hours = Array.apply(null, Array(24)).map(function (_, i) {
      if (`${i}`.length < 2) {
        return `0${i}`
      } else {
        return `${i}`
      }
      // return i
    })
    this.minutes30 = Array.apply(null, Array(2)).map(function (_, i) {
      if (`${i * 30}`.length < 2) {
        return `0${i * 30}`
      } else {
        return `${i * 30}`
      }
      // return (i * 30)
    })
    this.minutes15 = Array.apply(null, Array(4)).map(function (_, i) {
      if (`${i * 15}`.length < 2) {
        return `0${i * 15}`
      } else {
        return `${i * 15}`
      }
      // return (i * 15)
    })
    this.hours.forEach((hour) => {
      this.minutes30.forEach((minute) => {
        this.availableHours.push({ hour, minute })
      })
    })
  },
  methods: {
    ...mapActions({
      updateLocationOpeningHours: 'updateLocationOpeningHours'
    }),
    createOpeningHours () {
      this.openingHours = []
      this.days.forEach((day, index) => {
        this.openingHours.push(
          {
            day: day,
            jsDateIndex: day === 'Sunday' ? 0 : index + 1,
            isClosed: true,
            isNotAllDay: true,
            isSet: false,
            hours: {
              morning: null,
              afternoon: null
            },
            focused: { 0: false, 1: false, 2: false, 3: false },
            isEditing: -1,
            style: {},
            customValue: {
              0: '',
              1: '',
              2: '',
              3: ''
            }
          }
        )
      })
      this.previousOpeningHours = JSON.parse(JSON.stringify(this.openingHours))
    },
    handleCancel () {
      if (this.previousOpeningHours.length > 0) {
        this.openingHours = JSON.parse(JSON.stringify(this.previousOpeningHours))
      }
      this.dialog = false
    },
    handleSave () {
      let mapOpeningHoursInput = {}
      this.openingHours.forEach((openingHoursObject) => {
        const day = openingHoursObject.day.toLowerCase()
        mapOpeningHoursInput[day] = null
        if (!openingHoursObject.isNotAllDay) {
          const AllDayOpeningHours = {
            fromHours: 0,
            fromMinutes: 0,
            toHours: 23,
            toMinutes: 59
          }
          mapOpeningHoursInput[day] = { ...mapOpeningHoursInput[day], morning: AllDayOpeningHours }
        }
        if (openingHoursObject.hours.morning != null && openingHoursObject.isNotAllDay) {
          let morning = openingHoursObject.hours.morning
          delete morning['__typename']
          mapOpeningHoursInput[day] = { ...mapOpeningHoursInput[day], morning }
        }
        if (openingHoursObject.hours.afternoon != null && openingHoursObject.isNotAllDay) {
          let afternoon = openingHoursObject.hours.afternoon
          delete afternoon['__typename']
          mapOpeningHoursInput[day] = { ...mapOpeningHoursInput[day], afternoon }
        }
        if (openingHoursObject.isClosed) {
          mapOpeningHoursInput[day] = null
        }
        // if (this.openingHours.hours[0] != null) {
        //   const morningOpeningHours = this.hours[]
        //   const morning = {
        //     fromHours:
        //     fromMinutes:
        //     toHours:
        //     toMinutes:
        //   }
        // }
      })
      this.updateLocationOpeningHours({ location: { ...this.getSelectedResourceSecond, openingHours: mapOpeningHoursInput }, locationID: this.getSelectedResourceSecond.id, openingHours: mapOpeningHoursInput })
      this.$nextTick(() => {
        this.dialog = false
      })
    },
    handleClosed (state, index) {
      switch (state) {
        case 'open':
          this.openingHours[index] = {...this.openingHours[index], isClosed: false}
          break
        default:
          this.openingHours[index].isClosed = true
          this.openingHours[index].isNotAllDay = true
          this.openingHours[index].hours = []
          this.openingHours[index].isEditing = -1
          break
      }
      this.openingHours = [].concat(this.openingHours)
    },
    handleAllDay (state, index) {
      switch (state) {
        case 'open':
          this.openingHours[index].isNotAllDay = false
          break
        default:
          this.openingHours[index].isNotAllDay = true
          break
      }
      this.openingHours = [].concat(this.openingHours)
    },
    handleAddInterval (state, intervalIndex, index, flag) {
      switch (state) {
        case 'open_1':
          if (flag === 'add') {
            this.openingHours[index].hours.morning = {
              fromHours: 8,
              fromMinutes: 0,
              toHours: 17,
              toMinutes: 0
            }
          }
          const morning = this.openingHours[index].hours.morning
          this.openingHours[index].customValue[0] = this.$options.filters.openingHoursText({ hours: morning.fromHours, minutes: morning.fromMinutes })
          this.openingHours[index].customValue[1] = this.$options.filters.openingHoursText({ hours: morning.toHours, minutes: morning.toMinutes })
          this.openingHours[index].isEditing = 'morning'
          break
        case 'open_2':
          if (flag === 'add') {
            this.openingHours[index].hours.afternoon = {
              fromHours: 17,
              fromMinutes: 0,
              toHours: 23,
              toMinutes: 0
            }
          }
          const afternoon = this.openingHours[index].hours.afternoon
          this.openingHours[index].customValue[2] = this.$options.filters.openingHoursText({ hours: afternoon.fromHours, minutes: afternoon.fromMinutes })
          this.openingHours[index].customValue[3] = this.$options.filters.openingHoursText({ hours: afternoon.toHours, minutes: afternoon.toMinutes })
          this.openingHours[index].isEditing = 'afternoon'
          break
        default:
          this.openingHours[index].isEditing = -1
          break
      }
    },
    handleTypeTime (evt, intervalIndex, timeIndex, index, day) {
      let searchMatch = evt.target.value.match(this.searchRegex)
      let matches = evt.target.value.match(this.timeRegex)
      this.typedUser = evt.target.value
      this.openingHours[day].customValue[index] = evt.target.value
      if (searchMatch !== null) {
        this.typedFilter = searchMatch[0]
      } else if (evt.target.value === '1') {
        this.typedFilter = 'one'
      } else if (evt.target.value === '0') {
        this.typedFilter = 'zero'
      } else if (evt.target.value.length === 1) {
        let oneNumberMatch = evt.target.value.match(this.searchOneNumberRegex)
        if (oneNumberMatch !== null) {
          this.typedFilter = `0${oneNumberMatch[0]}`
        }
      }
      if (matches != null) {
        this.handleSelectValue(matches[0], intervalIndex, timeIndex, day, index)
      }
    },
    handleBlurInput (evt, intervalIndex, timeIndex, index, blurIndex) {
      let matches = this.typedUser.match(this.timeRegex)
      if (matches !== null) {
        this.openingHours[index].hours[intervalIndex][timeIndex] = matches[0]
      }
      setTimeout(() => {
        this.openingHours[index].focused[blurIndex] = false
        this.typedFilter = ''
        this.typedUser = ''
        matches = evt.target.value.match(this.timeRegex)
        if (matches === null) {
          this.handleSelectValue(this.openingHours[index].customValue[blurIndex], intervalIndex, timeIndex, index, blurIndex)
        }
      }, 100)
    },
    handleFocusInput (evt, intervalIndex, timeIndex, index, focusIndex) {
      this.typedUser = ''
      this.typedFilter = ''
      this.$nextTick(() => {
        this.openingHours[index].focused[focusIndex] = true
      })
    },
    handleSelectValue (value, intervalIndex, timeIndex, index, vmodelIndex) {
      this.typedUser = ''
      this.typedFilter = ''
      const numberValue = value.split(':').map((number) => Number(number))
      if (timeIndex === 'from') {
        this.openingHours[index].hours[intervalIndex] = { ...this.openingHours[index].hours[intervalIndex], ...{ fromHours: numberValue[0], fromMinutes: numberValue[1] } }
      } else if (timeIndex === 'to') {
        this.openingHours[index].hours[intervalIndex] = { ...this.openingHours[index].hours[intervalIndex], ...{ toHours: numberValue[0], toMinutes: numberValue[1] } }
      }
      // this.openingHours[index].hours[intervalIndex] = value
      this.openingHours[index].customValue[vmodelIndex] = value
    },
    removeInterval (index) {
      this.openingHours[index].hours.afternoon = null
    },
    handleMapOpeningHoursResponeToLocalData (responseOpeningHours) {
      Object.keys(responseOpeningHours).forEach((dayKey) => {
        const dayIndex = this.openingHours.findIndex(({ day }) => day.toLowerCase() === dayKey)
        if (responseOpeningHours[dayKey] != null) {
          const morning = responseOpeningHours[dayKey].morning
          const afternoon = responseOpeningHours[dayKey].afternoon
          if (morning != null) {
            if (morning.fromHours === 0 && morning.fromMinutes === 0 && morning.toHours === 23 && morning.toMinutes === 59) {
              this.openingHours[dayIndex] = { ...this.openingHours[dayIndex], isNotAllDay: false, isClosed: false }
            } else {
              let isClosed = true
              if (morning != null) {
                isClosed = false
                this.openingHours[dayIndex].hours = { ...this.openingHours[dayIndex].hours, morning }
                this.openingHours[dayIndex].customValue[0] = this.$options.filters.openingHoursText({ hours: morning.fromHours, minutes: morning.fromMinutes })
                this.openingHours[dayIndex].customValue[1] = this.$options.filters.openingHoursText({ hours: morning.toHours, minutes: morning.toMinutes })
                this.openingHours[dayIndex].isClosed = isClosed
                this.openingHours[dayIndex].isEditing = 'morning'

              }
              if (afternoon != null) {
                isClosed = false
                this.openingHours[dayIndex].hours = { ...this.openingHours[dayIndex].hours, afternoon}
                this.openingHours[dayIndex].customValue[2] = this.$options.filters.openingHoursText({ hours: afternoon.fromHours, minutes: afternoon.fromMinutes })
                this.openingHours[dayIndex].customValue[3] = this.$options.filters.openingHoursText({ hours: afternoon.toHours, minutes: afternoon.toMinutes })
                this.openingHours[dayIndex].isClosed = isClosed
                this.openingHours[dayIndex].isEditing = 'afternoon'
              }
            }
          } else {
            if (dayIndex >= 0) {
              this.openingHours[dayIndex] = { ...this.openingHours[dayIndex], isClosed: true }
            }
          }
        } else {
          if (dayIndex >= 0) {
            this.openingHours[dayIndex] = { ...this.openingHours[dayIndex], isClosed: true }
          }
        }
      })
    },
    parsingNumberToTimeString (numberTime) {
      return numberTime < 10 ? '0' + numberTime : numberTime.toString()
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedResourceSecond'
    ]),
    computedOpenHours: function () {
      if (this.typedFilter.length < 1) {
        let range = [0, this.hours.length]
        this.filterOpenHours.forEach((key, index) => {
          range[index] = this.hours.indexOf(key)
        })
        let newHours = []
        this.hours.slice(range[0], range[1] + 1).forEach((hour) => {
          this.minutes30.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else if (this.typedFilter === 'one') {
        let newHours = []
        this.hours.filter((hour) => {
          return hour.includes('1')
        }).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else if (this.typedFilter === 'zero') {
        let newHours = []
        this.hours.filter((hour) => {
          return hour.includes('0')
        }).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else {
        let newHours = []
        let index = this.hours.indexOf(this.typedFilter)
        this.hours.slice(index, index + 4).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      }
    },
    computedCloseHours: function () {
      if (this.typedFilter.length < 1) {
        let range = [0, this.hours.length]
        this.filterCloseHours.forEach((key, index) => {
          range[index] = this.hours.indexOf(key)
        })
        let newHours = []
        this.hours.slice(range[0], range[1] + 1).forEach((hour) => {
          this.minutes30.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else if (this.typedFilter === 'one') {
        let newHours = []
        this.hours.filter((hour) => {
          return hour.includes('1')
        }).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else if (this.typedFilter === 'zero') {
        let newHours = []
        this.hours.filter((hour) => {
          return hour.includes('0')
        }).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      } else {
        let newHours = []
        let index = this.hours.indexOf(this.typedFilter)
        this.hours.slice(index, index + 4).forEach((hour) => {
          this.minutes15.forEach((minute) => {
            newHours.push(`${hour}:${minute}`)
          })
        })
        return newHours
      }
    },
    computedDay () {
      if (this.openingHours.length > 0) {
        let currentDateIndex = new Date().getDay()
        let openingHoursIndex = this.openingHours.findIndex(({ jsDateIndex }) => {
          return jsDateIndex === currentDateIndex
        })
        let today = {}
        if (this.openingHours[openingHoursIndex].isNotAllDay) {
          today['attribute'] = this.openingHours[openingHoursIndex].isClosed ? `${this.$t('hours.closed')}` : `${this.$t('hours.opened')}: `
          today['value'] = this.openingHours[openingHoursIndex].isClosed ? null :
          `${this.$options.filters.openingHoursContext(this.openingHours[openingHoursIndex].hours.morning)}${this.openingHours[openingHoursIndex].hours.afternoon != null ? ', ': ''} ${this.$options.filters.openingHoursContext(this.openingHours[openingHoursIndex].hours.afternoon)}`
        } else {
          today['attribute'] = `${this.$t('hours.opened')}: `
          today['value'] = `24 ${this.$t('shipments.hours')}`
        }
        return today
      } else {
        return null
      }
    }
  },
  watch: {
    dialog: {
      handler: function (val, oldVal) {
        if (val) {
          if (this.openingHours != null) {
            this.previousOpeningHours = JSON.parse(JSON.stringify(this.openingHours))
          }
        } else {
          this.handleMapOpeningHoursResponeToLocalData(this.location.openingHours)
        }
      }
    },
    location: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        this.createOpeningHours()
        if (val.openingHours != null) {
          this.handleMapOpeningHoursResponeToLocalData(val.openingHours)
        }
      }
    }
  }
}
</script>

<style lang="scss">
input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    outline: none;
    border: none;
    background-color: transparent;
    color: inherit;
    font-family: inherit;
    color: #484848;
    background-color: white;
    font-weight: bold;
    font-size: $titleFontSize;
    width: 45px;
    margin-right: 5px;
  }
.opening--hours--timepicker {
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 9;
  input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    outline: none;
    border: none;
    background-color: transparent;
    color: inherit;
    font-family: inherit;
    color: #484848;
    background-color: white;
    font-weight: bold;
    font-size: $titleFontSize;
    width: 45px;
    margin-right: 5px;
  }
  // div {
  //   display: flex;
  //   flex-direction: column;
  //   flex-wrap: nowrap;
  //   width: 45px;
  //   max-height: 68px;
  //   height: 68px;
  //   overflow-y: auto;
  //   a {
  //     &.bgLight {
  //       background-color: #cecece;
  //     }
  //     background-color: white;
  //     flex: 1 1 100%;
  //     width: 100%;
  //   }
  // }
}
.editing--opening--hours {
  height: 100%;
  width: 100%;
  background-color: #fafafa;
  ul {
    list-style-type: none;
    overflow-y: auto;
    padding: 20px;
    li {
      margin-bottom: 20px;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      align-content: space-between;
      justify-content: center;
      background-color: white;
      padding: 10px 5px;
      &:last-child {
        border-bottom: 1px;
      }
      span {
        &.visibilityHidden {
          visibility: hidden;
        }
        i {
          padding-right: 5px;
        }
        text-align: center;
        &:first-child {
          text-align: left;
        }
        &.timePickers {
          flex: 1 1 25%;
          width: 25%;
          height: 70%;
          .span--wrapper {
            display: inline-block;
            height: 100%;
            width: 70px;
          }
        }
        &.opening--hours--addinterval {
          &:hover {
            cursor: pointer;
            background-color: #fafafa;
          }
        }
        position: relative;
        flex: 1 1 25%;
        width: 25%;
        font-size: 13px;
        font-weight: 500;
        color: #767676;
        margin-right: 1%;
      }
    }
  }
}

</style>
